import bugsnag from "@bugsnag/js";

export default {
  getUserInfo() {
    try {
      return JSON.parse(localStorage.getItem("USER_INFO"));
    } catch (e) {
      bugsnag.notify(new Error(e));
    }
  },

  getRole() {
    const user = this.getUserInfo();
    return user ? user.role : "VISITOR";
  },

  getUserId() {
    const user = this.getUserInfo();

    return user.id;
  },

  setUserInfo(user) {
    localStorage.setItem("USER_INFO", JSON.stringify(user));
  },

  getAccessToken() {
    try {
      const token = localStorage.getItem("ACCESS_TOKEN");
      return token;
    } catch (e) {
      bugsnag.notify(new Error(e));
    }
  },

  setAccessToken(token) {
    localStorage.setItem("ACCESS_TOKEN", token);
  },

  destroy() {
    localStorage.removeItem("ACCESS_TOKEN");
    localStorage.removeItem("USER_INFO");
  },
};
